import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { SellpropertyComponent } from './sellproperty/sellproperty.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ListingComponent } from './listing/listing.component';
import { PropertysingleComponent } from './propertysingle/propertysingle.component';
import { TermsconditionComponent } from './termscondition/termscondition.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { CareersComponent } from './careers/careers.component';
import { RequestinfoComponent } from './requestinfo/requestinfo.component';
import { HelpcenterComponent } from './helpcenter/helpcenter.component';
import { SalesenquiryComponent } from './salesenquiry/salesenquiry.component';
import { PropertyallComponent } from './propertyall/propertyall.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ReportproblemComponent } from './reportproblem/reportproblem.component';
import { ContactComponent } from './contact/contact.component';
import { RequestCallbackComponent } from './request-callback/request-callback.component';
import { PropiracontactComponent } from './propiracontact/propiracontact.component';
import { ListforsaleComponent } from './listforsale/listforsale.component';
import { QuicklistingComponent } from './quicklisting/quicklisting.component';
import { FranchiseeFormComponent } from './franchisee-form/franchisee-form.component';
import { UserFeedbackComponent } from './user-feedback/user-feedback.component';
import { SalespropertiesComponent } from './salesproperties/salesproperties.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'in/buy/:city', component: HomeComponent },
	{ path: 'in/rent/:city', component: HomeComponent },
	{ path: 'in/pg/:city', component: HomeComponent },
	{ path: 'in/findAnAgent/:city', component: HomeComponent },
	{ path: 'forgot-password', component: ForgotpasswordComponent },
	{ path: 'profile',loadChildren: './profile/profile.module#ProfileModule',},
	{ path:'buy',redirectTo:'buy/property-in-alwar',pathMatch:'full'},
	{ path:'rent',redirectTo:'rent/property-in-alwar',pathMatch:'full'},
	{ path:'buy/residential',redirectTo:'buy/residential-property-for-sale-in-alwar',pathMatch:'full'},
	{ path:'buy/commercial',redirectTo:'buy/commercial-property-for-sale-in-alwar',pathMatch:'full'},
	{ path:'buy/agriculture',redirectTo:'buy/agriculture-land-for-sale-in-alwar',pathMatch:'full'},
	{ path:'buy/industrial',redirectTo:'buy/industrial-property-for-sale-in-alwar',pathMatch:'full'},
	{ path:'rent/residential',redirectTo:'rent/residential-property-for-rent-in-alwar',pathMatch:'full'},
	{ path:'rent/commercial',redirectTo:'rent/commercial-property-for-rent-in-alwar',pathMatch:'full'},
	{ path:'rent/agriculture',redirectTo:'rent/agricultural-land-for-rent-in-alwar',pathMatch:'full'},
	{ path:'rent/industrial',redirectTo:'rent/industrial-property-for-rent-in-alwar',pathMatch:'full'},
	{ path:'pg',redirectTo:'pg-in-alwar',pathMatch:'full'},

	{
		path: 'buy/:city',
		component: ListingComponent,
		data: {
			breadcrumb_type: 'buy',
			heading_tag: 'Property For Sale in :city',
			// heading_tag: 'Buy Properties/Lands/Apartments',
			title: 'Property in :city - Real Estate Property For Sale in :city | Propira',
			keywords:
				'buy property in Alwar, real estate company, Alwar real estate, buy house in Alwar, buy residential property in Alwar, residential properties for sale in Alwar, buy commercial property in Alwar, commercial property for sale, buy agriculture property in Alwar, agriculture property for sale, buy industrial property in Alwar, industrial property for sale',
			description:
				"Find properties for sale in :city on Propira. Explore flats, villas, ready-to-move apartments for sale, and 100% verified listings. Visit now!",
			property_type: '2',
			propertytype_name: 'buy'
		}
	},
	{
		path: 'buy/:city/:sublocality',
		component: ListingComponent,
		data: {
			breadcrumb_type: 'buy',
			heading_tag: 'Property For Sale in :city',
			// heading_tag: 'Buy Properties/Lands/Apartments',
			title: 'Property in :city - Real Estate Property For Sale in :city | Propira',
			keywords:
				'buy property in Alwar, real estate company, Alwar real estate, buy house in Alwar, buy residential property in Alwar, residential properties for sale in Alwar, buy commercial property in Alwar, commercial property for sale, buy agriculture property in Alwar, agriculture property for sale, buy industrial property in Alwar, industrial property for sale',
			description:
				"Find properties for sale in :city on Propira. Explore flats, villas, ready-to-move apartments for sale, and 100% verified listings. Visit now!",
			property_type: '2',
			propertytype_name: 'buy'
		}
	},
	{
		path: 'rent/:city/:sublocality',
		component: ListingComponent,
		data: {
			breadcrumb_type: 'rent',
			heading_tag: 'Property For Sale in :city',
			// heading_tag: 'Buy Properties/Lands/Apartments',
			title: 'Property in :city - Real Estate Property For Sale in :city | Propira',
			keywords:
				'buy property in Alwar, real estate company, Alwar real estate, buy house in Alwar, buy residential property in Alwar, residential properties for sale in Alwar, buy commercial property in Alwar, commercial property for sale, buy agriculture property in Alwar, agriculture property for sale, buy industrial property in Alwar, industrial property for sale',
			description:
				"Find properties for sale in :city on Propira. Explore flats, villas, ready-to-move apartments for sale, and 100% verified listings. Visit now!",
			property_type: '1',
			propertytype_name: 'rent'
		}
	},
	{
		path: 'rent/:city',
		component: ListingComponent,
		data: {
			breadcrumb_type: 'rent',
			heading_tag: 'Property For Rent in :city',
			// heading_tag: 'Properties for Rent',
			title: 'Property For Rent in :city | Flats, Apartment, House - Propira',
			keywords:
				'property for rent, properties for rent, property for rent in Alwar, rental properties in Alwar, commercial rental property in Alwar, agriculture rental property in Alwar, industrial rental property in Alwar, residential rental property in Alwar',
			description:
				'Explore properties for rent in :city at Propira. Find flats, houses, and apartments for rent in :city, with all the facilities & no brokerage. Enquire now!',
			property_type: '1',
			propertytype_name: 'rent'
		}
	},
	{
		path: 'pg/:city',
		component: ListingComponent,
		data: {
			breadcrumb_type: 'pg',
			heading_tag: 'PG For Boys/Girls in :city',
			// heading_tag: 'Best Pg for Girls and Boys',
			title: 'PG For Boys/Girls in :city | Find PG in :city - Propira',
			keywords:
				'Affordable PG in Alwar, Paying Guests for Rent in Alwar, PG Accommodation in Alwar, PG for Boys in Alwar, Single Room PG in Alwar, PG for Rent in Alwar',
			description:
				"Find PG for boys and girls in :city at low prices on Propira. Explore all the amenities like WiFi, food, electricity, etc. No brokerage. Enquire now!",
			property_type: '3',
			propertytype_name: 'pg',
			looking_type: '5'
		}
	},

	{ path: 'details/pg/:slug', component: PropertysingleComponent, data: { property_type_name: 'pg' } },
	{
		path: 'details/:lookingtype/:lookingsubcat/:slug',
		component: PropertysingleComponent,
		data: { property_type_name: 'sell_rent' }
	},
	{ path: 'term-condition', component: TermsconditionComponent },
	{ path: 'privacy-policy', component: PrivacypolicyComponent },
	{ path: 'sell-property', component: SellpropertyComponent },
	{ path: 'about-us', component: AboutusComponent },
	{ path: 'careers', component: CareersComponent },
	{ path: 'request-info', component: RequestinfoComponent },
	{ path: 'help-center', component: HelpcenterComponent },
	{ path: 'sales-enquiry', component: SalesenquiryComponent },
	{ path: 'testimonials', component: TestimonialsComponent },
	{ path: 'propertyall/:id', component: PropertyallComponent },
	{ path: 'report-problem', component: ReportproblemComponent },
	{ path: 'contact-us', component: ContactComponent },
	{ path: 'franchisee-request', component: FranchiseeFormComponent },
	{ path: 'request-callback', component: RequestCallbackComponent },
	{ path: 'propira-contact', component: PropiracontactComponent },
	{ path: 'property-list-for-sale', component: ListforsaleComponent },
	{ path: 'blog', loadChildren: './blog/blog.module#BlogModule' },
	{ path: 'quick-listing', component: QuicklistingComponent },
	{
		path: 'facilities-for-property',
		loadChildren: './vastu-services/vastu-services.module#VastuServiceModule'
	},
	{ path: 'profile/list-your-property', redirectTo: 'quick-listing' },
	{ path: 'feedback', component: UserFeedbackComponent },
	{ path: '404', component: PagenotfoundComponent },
	{ path:"project",loadChildren:"./project/project.module#ProjectModule"},
	{ path: 'sales-properties/:type', component: SalespropertiesComponent },
	{ path: 'agent', loadChildren: "./agent/agent.module#agentModule" },
	{ path: '**', redirectTo: '404' }
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			onSameUrlNavigation: 'reload',
			scrollPositionRestoration: 'enabled'
		})
	],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
